import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { userPageModel } from '../../model';
import { UserPageForm } from '../user-page-form';
import { UserPageHeading } from '../user-page-heading';

export const UserPage = () => {
	const loading = useUnit(userPageModel.getUserQuery.$pending);

	return (
		<AppShell.Main>
			{loading ? (
				<Loader />
			) : (
				<>
					<UserPageHeading />
					<UserPageForm />
				</>
			)}
		</AppShell.Main>
	);
};
